import React, { useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { CoFounderConnectBreadCrum } from '../core/_constants'
import RectangularTabs from '../../widgets/components/RectangularTabs'
import PublishYourRequirements from '../components/PublishYourRequirements'
import SearchCoFounders from '../components/SearchCoFounders'
import PublishCofounderRequirementModal from '../components/PublishCofounderRequirementModal'
// import { useAuth } from '../../auth'

const CoFounderConnect = () => {
    const { formatMessage } = useIntl()
    // const { planStatus } = useAuth()
    const [isModalActive, setIsModalActive] = useState(false)

    const options = [
        {
            id: 1,
            slug: 'Vote-For-Other-Startups',
            title: formatMessage({ id: 'Co-Founders Openings' }),
            subTitle: formatMessage({ id: 'Co-Founder Opportunities Posted by Others' }),
        },
        {
            id: 2,
            slug: 'Publish-Your-Requirements',
            title: formatMessage({ id: 'Publish Your Requirement' }),
            subTitle: formatMessage({ id: 'Post a Co-Founder Opening for Your Startup' }),
        },
    ]

    // State for managing the selected tab
    const [selectedTab, setSelectedTab] = useState<number>(1)

    const handleTabChange = (id: number) => {
        setSelectedTab(id)
    }

    return (
        <div className='px-6'>
            <PageTitle
                breadcrumbs={CoFounderConnectBreadCrum}
                description={formatMessage({ id: 'Co-Founder Connect' })}
            >
                {formatMessage({ id: 'Co-Founder Connect' })}
            </PageTitle>
            {/* button for Desktop view */}
            <div
                // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block ${planStatus === 'payment_due' && 'planstatus-adjustment'}  ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}
                className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
                style={{ top: '80px', right: '30px' }}
            >
                <div className='d-flex flex-column mt-3 top-btn-main'>
                    <div className='d-flex justify-content-end'>
                        <button
                            className={`btn btn-bg-primary font-size-13 text-white font-weight-400 w-100 ${selectedTab !== 2 && 'd-none'
                                }`}
                            onClick={() => setIsModalActive(true)}
                        >
                            {formatMessage({ id: 'Publish Co-Founder Requirement ' })}
                        </button>

                    </div>
                </div>
            </div>
            {/* button for mobile view */}
            <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none'>
                <div className='d-flex flex-column mt-3 top-btn-main'>
                    <div className='d-flex justify-content-end'>
                        <button
                            className={`btn btn-bg-primary font-size-13 text-white mb-4 font-weight-400 w-100 ${selectedTab !== 2 && 'd-none'
                                }`}
                            onClick={() => setIsModalActive(true)}
                        >
                            {formatMessage({ id: 'Publish Co-Founder Requirement ' })}
                        </button>
                    </div>
                </div>
            </div>
            <RectangularTabs
                options={options}
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
            />
            <div className='my-auto w-100 '>
                {(selectedTab === 1) && (
                    <SearchCoFounders />
                )}

                {(selectedTab === 2) && (
                    <PublishYourRequirements />
                )}
            </div>
            {isModalActive && <PublishCofounderRequirementModal isModalActive={isModalActive} setIsModalActive={setIsModalActive} />}
        </div>
    )
}

export default CoFounderConnect
